import React from 'react';

const PostList = ({ formData }) => {
    const blogUrl = process.env.NODE_ENV === 'production'
    ? 'https://blog.stemcellsoft.com'
    : 'http://blog.localhost:3000';

    // 格式化日期
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const diffTime = Math.abs(now - date);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays === 1) return '昨天';
        if (diffDays <= 7) return `${diffDays} 天前`;
        if (diffDays <= 30) return `${Math.ceil(diffDays / 7)} 週前`;
        return date.toLocaleDateString('zh-TW');
    };

    // 截取內容預覽
    const getContentPreview = (content) => {
        if (!content) return '';
        return content.length > 80 ? content.substring(0, 80) + '...' : content;
    };

    return (
        <div className='new-post-item'>
            <a className='new-post-link' href={`${blogUrl}/p?id=${formData.shortPostId}`}>
                <div className='new-post-content'>
                    <h3 className='new-post-title'>{formData.title}</h3>
                    <p className='new-post-excerpt'>{getContentPreview(formData.content)}</p>
                    <div className='new-post-meta'>
                        <span className='new-post-author'>{formData.author || 'Jim'}</span>
                        <span className='new-post-date'>{formatDate(formData.createdAt)}</span>
                    </div>
                </div>
                <div className='new-post-indicator'>
                    <svg className='new-post-icon' viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                </div>
            </a>
        </div>
    );
};

export default PostList;